// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"98c25bb1","534":"240d8225","583":"32add9b8"}[chunkId] + ".chunk.js";
};